module.exports = __webpack_public_path__ + "img/3.1f6a18b1.jpg";